
<div class="teaser teaser-floated-image" data-column-span="6">
  <div class="teaser-image">
  </div>
  <div class="teaser-content">
    <div class="teaser-heading teaser-heading-small teaser-heading-lowercase">
      <h3 class=tile__title>
        <mibp-resource-string key="Users_Notifications_Tab_Title"></mibp-resource-string>
      </h3>
    </div>
    @if (!hasUnreadNotifications) {
      <div>
        <mibp-resource-string key="MyActivity_NoNotificationsText"></mibp-resource-string>
      </div>
    }
    @if (hasUnreadNotifications) {
      <div class="list notification">
        <!-- loop here -->
        @for (notification of notifications; track notification) {
          <div class="list-item">
            <div class="list-item-icon"><i class="icon-0"></i></div>
            <div class="list-item-content">
              <span class="foldout-menu__activity__time"><mibp-datetime [date]="notification.date" format="datetime"></mibp-datetime></span>
              <h4><a href="{{ notification.url }}" (click)="notificationService.view(notification)" ><mibp-resource-string [key]="notification.titleResourceStringKey" [formatFunction]="formatNotificationText" [macros]="{ args: notification.args }"></mibp-resource-string></a></h4>
              <p><mibp-resource-string [key]="notification.descriptionResourceStringKey" [formatFunction]="formatNotificationText" [macros]="{ args: notification.args }"></mibp-resource-string></p>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div id="content" class="tile__footer">
    <button type="button" class="my-button" (click)="showAll()"><mibp-resource-string key="MyActivity_ShowAll"></mibp-resource-string></button>
  </div>
</div>
